export enum MixpanelExtraParamsKeys {
  SOURCE = 'src',
  TAB = 'tab',
}

export const DeductionSourceParamValues: string[] = ['invoice'];

export interface MixpanelExtraParams {
  [MixpanelExtraParamsKeys.SOURCE]?: string;
  [MixpanelExtraParamsKeys.TAB]?: string;
}

export enum Modules {
  DEDUCTIONS = 'deductions',
}
